// extracted by mini-css-extract-plugin
export default {"starIcon":"hotelCardStars-module__starIcon__LT1hY","starsContainer":"hotelCardStars-module__starsContainer__H3sFD"};